import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';
import collectPrintTechAnalysis from 'editor/src/util/printTechAnalysis/collectPrintTechAnalysis';
import { PRINT_TECH_ANALYSIS_VERSION } from 'editor/src/util/printTechAnalysis/types';

/**
 * GAPI-43148 — responds to the host's `design.requestPrintTechAnalysis`. Computes
 * raw artwork signals for the current design and replies with
 * `design.printTechAnalysisChanged` (echoing requestId). When analysis is disabled
 * via host settings it replies with empty areas so the host doesn't wait for its
 * timeout. The recommendation decision (DTF vs DTG) is made by the host.
 */
const requestPrintTechAnalysisOperation =
  (requestId: string) => async (_dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();

    if (!state.hostSettings.enablePrintTechAnalysis) {
      sendPostMessage('design.printTechAnalysisChanged', {
        requestId,
        analysisVersion: PRINT_TECH_ANALYSIS_VERSION,
        designHash: '',
        areas: [],
      });
      return;
    }

    const analysis = await collectPrintTechAnalysis(state.design.designData, state.gallery.images);
    sendPostMessage('design.printTechAnalysisChanged', {
      requestId,
      ...analysis,
    });
  };

export default requestPrintTechAnalysisOperation;
